import styled from 'styled-components';

export const StepNavContainer = styled.nav<{ $width?: number | string }>`
  width: ${({ $width }) =>
    typeof $width === 'number' ? `${$width}px` : ($width ?? '220px')};
  flex-shrink: 0;
  padding-right: 20px;
  border-right: 1px solid ${({ theme }) => theme.divider};
`;

export const StepItem = styled.div<{ $active?: boolean; $done?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid
    ${({ theme, $active, $done }) =>
      $active || $done ? theme.palette.primary.main : '#D1D5DB'};
  border-radius: 8px;
  background: ${({ $active, $done }) =>
    $active ? '#fff' : $done ? '#F3FBF8' : '#F9FAFB'};
  color: ${({ theme, $active, $done }) =>
    $active || $done ? theme.palette.primary.main : '#1F2A37'};
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  .step-number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    background: ${({ theme, $done }) =>
      $done ? theme.palette.primary.main : 'transparent'};
    color: ${({ theme, $active, $done }) =>
      $done ? '#fff' : $active ? theme.palette.primary.main : '#1F2A37'};
    border: 1px solid
      ${({ theme, $active, $done }) =>
        $active || $done ? theme.palette.primary.main : '#1F2A37'};
  }
  & + & {
    margin-top: 10px;
  }
`;
